const EX_CONSTANTS = {
    'documentExtensionNameMap': {
        'DOC': 'Word 97-2003 Document',
        'DOCX': 'Word Document',
        'PPT': 'PowerPoint 97-2003 Presentation',
        'PPTX': 'PowerPoint Presentation',
        'XLS': 'Excel 97-2003 Workbook',
        'XLSX': 'Excel Workbook'
    },
    'supportedImageExtensions': [
        'png',
        'jpg',
        'jpeg',
        'gif',
        'tif',
        'tiff',
        'bmp',
        'png',
        'psd',
        'psp',
        'svg'
    ],
    'supportedVideoExtensions': [
        'ogg',
        'mp4',
        'webm'
    ]
};
const FILE_UPLOAD_CONFIG = "fileUploader";
const DEFAULT_ALLOWED_FILE_TYPES = [
    "jpeg",
    "jpg",
    "png",
    "tiff",
    "bmp",
    "gif",
    //docs
    "pdf",
    "txt",
    "doc",
    "docx",
    "ppt",
    "pptx",
    "xls",
    "xlsx",
    //compressed
    "zip",
    "rar",
    "7zip",
    "gzip"
];
var whiteList = null;
const logger = console;
export class UtilUploads {
    /**
     * Looks for the needle in the array haystack and returns the index
     * @param needle the needle
     * @param arrHayStack the arrHayStack
     * @returns The index of needle in arrHayStack else -1
     */
    static getItemIndex(needle, arrHayStack) {
        return arrHayStack.indexOf(needle);
    }
    /**
     * Checks if file is an image.
     * @param fileName the provided file name
     * @returns boolean the result
     */
    static isImageFile(fileName) {
        const ext = UtilUploads.getExtension(fileName).toLowerCase();
        return UtilUploads.filterImage(ext);
    }
    /**
     * Given a file name, returns the extension in uppercase
     * @param fileName the file name
     * @returns string the result
     */
    static getExtension(fileName) {
        const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
        return ext.toUpperCase();
    }
    /**
     * Returns true if the extension is an image
     * @param ext extension
     * @returns boolean the result
     */
    static filterImage(ext) {
        const result = UtilUploads.arrayContains(ext.toLowerCase(), EX_CONSTANTS.supportedImageExtensions);
        return result;
    }
    /**
     * Looks for the needle in the array haystack
     * @param needle the needle
     * @param arrHayStack the arrHayStack
     * @returns boolean the result
     */
    static arrayContains(needle, arrHayStack) {
        return UtilUploads.getItemIndex(needle, arrHayStack) > -1;
    }
    static whiteListed(fileType, fileUploadConfig) {
        if (!fileType)
            fileType = 'unknown';
        fileType = fileType.toLowerCase();
        //if not strict then allow file types with the unknown extension (set at Uploader.js when it can't get
        // the extension from filename. Also set at PlainDirectoryProvider when it can't get the magic number from file's contents)
        if (fileType === 'unknown') {
            return true;
        }
        if (whiteList == null) {
            var fileUpload = fileUploadConfig;
            if (fileUpload && fileUpload.extensionWhitelist && Array.isArray(fileUpload.extensionWhitelist)) {
                whiteList = fileUpload.extensionWhitelist;
                logger.warn("DEPRECATED: please use allowlist and denylist instead of whitelist and blacklist.");
            }
            else if (fileUpload && fileUpload.extensionAllowlist && Array.isArray(fileUpload.extensionAllowlist)) {
                whiteList = fileUpload.extensionAllowlist;
            }
            else {
                whiteList = DEFAULT_ALLOWED_FILE_TYPES;
            }
        }
        return whiteList.indexOf(fileType) > -1;
    }
}
